import { gql } from '@apollo/client';

const COPY_ORDER_MODEL_VARIANTS_FROM_MODEL = gql`
  mutation CopyOrderVariantsFromModel($orderModelId: ID!) {
    copyOrderModelVariantsFromModel(orderModelId: $orderModelId) {
      orderModel {
        id
      }
    }
  }
`;

export default COPY_ORDER_MODEL_VARIANTS_FROM_MODEL;
